import { render, staticRenderFns } from "./leiji.vue?vue&type=template&id=431e704e&scoped=true&"
import script from "./leiji.vue?vue&type=script&lang=js&"
export * from "./leiji.vue?vue&type=script&lang=js&"
import style0 from "./leiji.vue?vue&type=style&index=0&id=431e704e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431e704e",
  null
  
)

export default component.exports